export enum MediaType {
  Picture = 0,
  Video = 1,
  PictureAndVideo = 2,
  Unknown = 3,
}
